module.exports = __webpack_public_path__ + "img/new_spotd9.8aa3d953.gif";